import { describeAction } from './toolLabels';

const GROUPS = Object.freeze({
	search: { title: 'Firmen suchen', tools: ['resolve_industry', 'search_companies', 'refine_company_set'] },
	qualify: { title: 'Firmen prüfen (KI)', tools: ['qualify_candidates'] },
	stock: { title: 'Bestand prüfen', tools: ['search_contacts', 'probe_maps'] },
	buy: { title: 'Firmen übernehmen', tools: ['create_prospect_query'] },
	enrich: { title: 'Kontakte anreichern', tools: ['start_enrichment'] },
	maps: { title: 'Google-Maps-Suche', tools: ['start_maps_run'] },
});

const GROUP_OF_TOOL = new Map(Object.entries(GROUPS).flatMap(([key, group]) => group.tools.map((tool) => [tool, key])));

const formatCount = (value) => (typeof value === 'number' ? value.toLocaleString('de-DE') : null);

const lastDone = (steps) => [...steps].reverse().find((step) => step.status === 'ok');

const searchSummary = (steps) => {
	const searches = steps.filter((step) => step.tool !== 'resolve_industry');
	const last = lastDone(searches);
	const total = formatCount(last?.summary?.total);
	if (total === null) return searches.length === 0 ? 'Branche aufgelöst' : null;
	const approx = last.summary.countKind && last.summary.countKind !== 'exact' ? 'ca. ' : '';
	const prefix = searches.length > 1 ? `${searches.length} Suchen · ` : '';
	return `${prefix}${approx}${total} Firmen gefunden`;
};

const groupStatus = (steps) => {
	if (steps.some((step) => step.status === 'pending')) return 'pending';
	if (steps.some((step) => step.status === 'error')) return 'error';
	return 'ok';
};

const summarize = (key, steps) => {
	if (key === 'search') return searchSummary(steps);
	const last = lastDone(steps);
	return last ? describeAction(last) : null;
};

/**
 * Bundles the tool steps of one assistant turn into activity groups: consecutive steps that
 * belong to the same activity (e.g. all company searches) form one group with a plain title, an
 * aggregate status and a one-line summary from the last finished step. Tools without a group
 * get a group of their own under the tool's German name.
 *
 * @param {Array<{tool: string, status: 'ok'|'error'|'pending', summary?: object, operationId?: string, seq?: number}>} steps
 * @returns {Array<{id: string, key: string, title: string, status: 'ok'|'error'|'pending', summary: string|null, steps: Array<object>}>}
 */
export function groupSteps(steps) {
	const groups = [];
	for (const step of steps) {
		const key = GROUP_OF_TOOL.get(step.tool) ?? step.tool;
		const last = groups[groups.length - 1];
		if (last && last.key === key) last.steps.push(step);
		else
			groups.push({
				id: String(step.operationId ?? step.seq),
				key,
				title: GROUPS[key]?.title ?? step.tool,
				steps: [step],
			});
	}
	return groups.map((group) => ({
		...group,
		status: groupStatus(group.steps),
		summary: summarize(group.key, group.steps),
	}));
}
